/**
 * Returns the best URL for a user profile.
 * Uses vanity URL (/u/username) when available, falls back to UUID (/users/id).
 */
export function getProfileUrl(userId: string, username?: string | null): string {
  if (username) {
    return `/u/${username}`;
  }
  return `/users/${userId}`;
}
